module.exports = __webpack_public_path__ + "img/icona4.5e363d6a.png";